// extracted by mini-css-extract-plugin
export default {"zoomModal":"s2-z"};